<template>
  <div class="container mx-auto px-4 text-center mt-2">
    <div class="inline-block py-4">
      <div class="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4">
        <a
          href="https://discord.gg/ccleaf"
          target="_blank"
          class="block transform transition-transform duration-200 hover:scale-105"
        >
          <img
            src="@/assets/logos/vault_discord.png"
            alt="Join CCleaf Discord Server"
            class="h-auto w-full sm:max-w-xl mx-auto max-w-full pt-6"
          >
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
</script>